import { LogoGithub } from '@carbon/icons-react';
import HomepageTemplate from "../../../../src/components/Homepage.js";
import Repositories from "../../../../src/components/Repositories";
import * as React from 'react';
export default {
  LogoGithub,
  HomepageTemplate,
  Repositories,
  React
};